import { ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, mergeMap } from 'rxjs/operators';

/**
 * Emits whether `element` is in view. `root` defaults to the viewport; pass the scrolling element
 * instead when the observed element lives inside a scroll container rather than in the page flow.
 * `rootMargin` grows the root's box, so an element sitting on its edge still counts as in view.
 */
export const createAndObserveIntersection = (
  element: ElementRef,
  root?: Element | null,
  rootMargin?: string
): Observable<boolean> => {
  return new Observable((observer) => {
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        observer.next(entries);
      },
      { root: root ?? null, rootMargin }
    );

    if (element?.nativeElement) {
      intersectionObserver.observe(element.nativeElement);
    }

    return () => {
      intersectionObserver.disconnect();
    };
  }).pipe(
    mergeMap((entries: any) => entries),
    map((entry: any) => entry.isIntersecting),
    distinctUntilChanged()
  );
};
